<template>
    <CardBorder>
        <template v-for="(record, index) in lodash.get(data.useForm.modelRef, itemsKey)" :key="record.id || record._id">
            <CardBorder
                v-if="record.isDelete !== true"
                :title="visibleCardTitle ? $t('views.request.informProduct.record', { seq: index + 1 }) : null"
                :style="{ marginBottom: index + 1 < lodash.get(data.useForm.modelRef, itemsKey).length ? '0.5rem !important' : '0 rem !important' }"
            >
                <TemplateBuilder
                    :rowProp="data.rowProp"
                    :useForm="data.useForm"
                    :fields="
                        createField({
                            props,
                            data: { ...data, productQty: data.productQty?.[record.id] },
                            key: `${itemsKey}.${index}`,
                            items: lodash.get(data.useForm.modelRef, itemsKey),
                            initItems: lodash.get(data.useForm.initialModel, itemsKey),
                            isLoading
                        })
                    "
                    :skeleton="isLoading"
                ></TemplateBuilder>
            </CardBorder>
        </template>
        <div class="has-error" v-if="data.useForm.validateInfos[itemsKey]?.validateStatus === 'error'">
            <div class="ant-form-explain">
                {{ data.useForm.validateInfos[itemsKey]?.help }}
            </div>
        </div>
    </CardBorder>
</template>

<script>
import lodash from "lodash";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../../app.logic";
import { createField, initData, isLoading } from "./hc-product.logic";

export default defineComponent({
    components: {
        TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
        CardBorder: defineAsyncComponent(() => import("../../../../../components/card/CardBorder"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: {},
        viewOnlyInspection: {},
        visibleCardTitle: { default: false },
        dataProp: {},
        itemsKey: {},
        fetchCriteria: {},
        canCreate: {},
        canDelete: {},
        informKey: {},
        request: {}
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        initData({ props, data, refs });
        return { props, data, refs, isLoading, lodash, createField };
    }
});
</script>
